export const scrollToError = (): void => {
  // エラー表示が反映されるのを待たせるため、setTimeOutを使用
  setTimeout(() => {
    window.scrollTo({
      top: window.pageYOffset + (document.getElementsByClassName("help is-danger")[0] as HTMLElement).getBoundingClientRect().y - 200,
      behavior: "smooth",
    });
  }, 0);
};
